import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Schools from './components/Schools.vue'

Vue.use(Router)


export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      children: [
        {
          path: '',
          component: Schools
        },
        {
          path: 'career',
          component: () => import(/* webpackChunkName: "career" */ './components/Career.vue')
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
    },
    {
      path: '/forgot_password',
      name: 'forgot_password',
      component: () => import(/* webpackChunkName: "login" */ './views/ForgotPassword.vue')
    },
    {
      path: '/database',
      name: 'database',
      component: () => import(/* webpackChunkName: "database" */ './views/Database.vue')
    },
    {
      path: '/mypage',
      name: 'mypage',
      component: () => import(/* webpackChunkName: "mypage" */ './views/MyPage.vue'),
      meta: { MyPageAuth: true },
    },
    {
      path: '/cart',
      name: 'cart',
      component: () => import(/* webpackChunkName: "cart" */ './views/Cart.vue'),
    },
    {
      path: '/mobile',
      name: 'mobile',
      component: () => import(/* webpackChunkName: "cart" */ './views/DetailMobile.vue'),
    },
    {
      path: '/essay',
      name: 'essay',
      component: () => import(/* webpackChunkName: "cart" */ './views/EssaySvg.vue'),
    },
    {
      path: '/terms',
      name: 'terms',
      component: () => import(/* webpackChunkName: "cart" */ './views/Terms.vue'),
    },
    {
      path: '/privacypolicy',
      name: 'privacypolicy',
      component: () => import(/* webpackChunkName: "cart" */ './views/PrivacyPolicy.vue'),
    },
  ]
})

